import { useDrag } from "client/hooks/utils/useDrag";
import { setActiveTextBoxId, setSettings } from "store/features/memeGenerator/actions";
import { TextBox } from "store/features/memeGenerator/types";
import { store, useAppDispatch } from "store/store";

export const useDragHandler = (textBox: TextBox) => {
    const dispatch = useAppDispatch();

    function onPointerDown() {
        dispatch(
            setSettings({
                id: textBox.id,
                draggingState: {
                    rotate: true,
                },
            }),
        );
    }

    function onPointerMove(left: number, top: number) {
        const _textBox = store.getState().memeGenerator.meme?.textBoxes.find((_t) => _t.id === textBox.id);
        if (!_textBox) return;
        dispatch(
            setSettings({
                id: textBox.id,
                left: _textBox.left + left,
                top: _textBox.top + top,
            }),
        );
        store.getState().memeGenerator.meme?.activeTextBoxId !== textBox.id && dispatch(setActiveTextBoxId(textBox.id));
    }

    function onPointerUp() {
        setTimeout(() => {
            dispatch(
                setSettings({
                    id: textBox.id,
                    draggingState: {
                        rotate: false,
                    },
                }),
            );
        }, 50);
    }

    const { dragHandlers, isDragging } = useDrag({
        onPointerDown,
        onPointerMove,
        onPointerUp,
        positionType: "relative",
    });

    return { dragHandlers, isDragging };
};
